import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { SUBSCRIBER_TEST_IDS } from '../../../brands/default/constants';
import { SUBSCRIBER_BUTTONS } from '../../../brands/default/content/components/forms';
import { Button } from './components';

export const SubscriberButtons = ({
  handleCloseButton,
  isAuthenticated,
  goToLogin,
  isBadConnection = false,
}) => {
  const { CLOSE_BUTTON, LOGIN_BUTTON } = SUBSCRIBER_TEST_IDS;
  const [showClose, setShowClose] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowClose(true);
    }, 5_000);
  }, []);

  if (isAuthenticated && showClose) {
    return (
      <div className="buttons-section">
        <Button
          className="login-modal login-modal--close"
          dataTestId={CLOSE_BUTTON}
          onClick={handleCloseButton}
          onKeyPress={handleCloseButton}
          text={SUBSCRIBER_BUTTONS.close}
          type="button"
        />
      </div>
    );
  }

  return (
    <div className="buttons-section">
      <Button
        className="login-modal"
        dataTestId={LOGIN_BUTTON}
        onClick={goToLogin}
        onKeyPress={goToLogin}
        text={SUBSCRIBER_BUTTONS.login}
        type="button"
      />
      {(showClose || isBadConnection) && (
        <Button
          className="close"
          dataTestId={CLOSE_BUTTON}
          onClick={handleCloseButton}
          onKeyPress={handleCloseButton}
        >
          <span aria-hidden="true">X</span>
          <span className="sr-only">{SUBSCRIBER_BUTTONS.close}</span>
        </Button>
      )}
    </div>
  );
};

SubscriberButtons.propTypes = {
  goToLogin: PropTypes.func.isRequired,
  handleCloseButton: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isBadConnection: PropTypes.bool,
};
